export const messages = {
  en: {
    rechargeOrder: {
      title: 'Recharge Orders',
      queryCondition: 'Query Conditions',
      orderNo: 'Order No.',
      orderNoPlaceholder: 'Please enter order number',
      userPhone: 'User Phone',
      userPhonePlaceholder: 'Please enter phone number',
      rechargeType: 'Recharge Type',
      rechargeTypePlaceholder: 'Please select recharge type',
      payStatus: 'Pay Status',
      payStatusPlaceholder: 'Please select pay status',
      payStatus0: 'Pending Payment',
      payStatus1: 'Paid',
      payStatus2: 'Payment Failed',
      payStatus3: 'Refunded',
      rechargeStatus: 'Recharge Status',
      rechargeStatusPlaceholder: 'Please select recharge status',
      rechargeStatus0: 'Pending',
      rechargeStatus1: 'Success',
      rechargeStatus2: 'Failed',
      query: 'Query',
      export: 'Export',
      import: 'Import',
      downloadTemplate: 'Download Template',
      startPayTime: 'Start Pay Time',
      startPayTimePlaceholder: 'Start Pay Time',
      endPayTime: 'End Pay Time',
      endPayTimePlaceholder: 'End Pay Time',
      fastCharge: 'Charge Type',
      fastChargePlaceholder: 'Charge Type',
      fastCharge1: 'Fast Charge',
      fastCharge2: 'Slow Charge',
      id: 'ID',
      payAmount: 'Pay Amount',
      faceAmount: 'Face Amount',
      deductAmount: 'Deduct Amount',
      paySn: 'Pay SN',
      thirdOrderNo: 'Third Order No.',
      remark: 'Remark',
      createTime: 'Create Time',
      payTime: 'Pay Time',
      finishTime: 'Finish Time',
      electricUnit: 'Electric Unit',
      electricAddr: 'Address',
      electricAccount: 'Electric Account',
      electricOwner: 'Owner Name',
      PHONE: 'Phone',
      ELECTRIC: 'Electric',
      WATER: 'Water',
      GAS: 'Gas',
      PROPERTY: 'Property',
      operation: 'Operation',
      refund: 'Refund',
      refundConfirmTitle: 'Refund Confirmation',
      refundConfirmMsg: 'Are you sure to refund order {orderNo}? Refund amount: {amount}',
      refundSuccess: 'Refund successful',
      refundFail: 'Refund failed',
      finishRecharge: 'Recharge Success',
      finishRechargeConfirmTitle: 'Confirmation',
      finishRechargeConfirmMsg: 'Are you sure to mark order {orderNo} as recharge success?',
      finishRechargeSuccess: 'Marked as recharge success',
      finishRechargeFail: 'Operation failed'
    }
  },
  zh: {
    rechargeOrder: {
      title: '充值订单',
      queryCondition: '查询条件',
      orderNo: '订单号',
      orderNoPlaceholder: '请输入订单号',
      userPhone: '用户手机号',
      userPhonePlaceholder: '请输入手机号',
      rechargeType: '充值类型',
      rechargeTypePlaceholder: '请选择充值类型',
      payStatus: '支付状态',
      payStatusPlaceholder: '请选择支付状态',
      payStatus0: '待支付',
      payStatus1: '已支付',
      payStatus2: '支付失败',
      payStatus3: '已退款',
      rechargeStatus: '充值状态',
      rechargeStatusPlaceholder: '请选择充值状态',
      rechargeStatus0: '待支付',
      rechargeStatus1: '充值处理中',
      rechargeStatus2: '充值成功',
      rechargeStatus3: '充值失败',
      rechargeStatus4: '已退款',
      query: '查询',
      export: '导出',
      import: '导入',
      downloadTemplate: '下载模板',
      startPayTime: '支付开始时间',
      startPayTimePlaceholder: '支付开始时间',
      endPayTime: '支付结束时间',
      endPayTimePlaceholder: '支付结束时间',
      fastCharge: '充值类型',
      fastChargePlaceholder: '充值类型',
      fastCharge1: '快充',
      fastCharge2: '慢充',
      id: '编号',
      payAmount: '实际支付金额',
      faceAmount: '到账金额',
      deductAmount: '抵扣金额',
      phone: '手机号',
      phoneName: '用户姓名',
      paySn: '支付单号',
      thirdOrderNo: '第三方订单号',
      remark: '备注',
      createTime: '下单时间',
      payTime: '支付时间',
      finishTime: '完成时间',
      electricUnit: '缴费单位',
      electricAddr: '小区+门牌号地址',
      electricAccount: '电费户号',
      electricOwner: '业主姓名',
      PHONE: '话费',
      ELECTRIC: '电费',
      WATER: '水费',
      GAS: '燃气费',
      PROPERTY: '物业费',
      operation: '操作',
      refund: '退款',
      refundConfirmTitle: '退款确认',
      refundConfirmMsg: '确定要退款订单 {orderNo} 吗？退款金额：{amount} 元',
      refundSuccess: '退款成功',
      refundFail: '退款失败',
      finishRecharge: '充值成功',
      finishRechargeConfirmTitle: '确认操作',
      finishRechargeConfirmMsg: '确定要将订单 {orderNo} 标记为充值成功吗？',
      finishRechargeSuccess: '已标记为充值成功',
      finishRechargeFail: '操作失败'
    }
  }
}